<ng-template #createTemplate let-item>
	<div class="flex justify-between items-center">
		<span class="mr-3">{{ item }}</span>
		<app-button
			(click)="_create()"
			size="small"
			[testHook]="testHooks.CreateButton"
			>Create</app-button
		>
	</div>
</ng-template>

<ng-template #itemTemplate let-item>
	<div *ngIf="item.type === clientTypes.PERSON" class="flex">
		<app-icon
			[icon]="!item.leap?.cardId ? ICON.PERSON : ICON.ADDRESS_CARD"
			class="mr-2"
			[testHook]="testHooks.PersonIcon"
		></app-icon
		><span class="whitespace-nowrap">{{ item | clientName }}</span>
	</div>
	<div *ngIf="item.type === clientTypes.CORPORATION" class="flex">
		<app-icon
			[icon]="ICON.CORPORATION"
			class="mr-2"
			[testHook]="testHooks.CorporationIcon"
		></app-icon
		><span class="whitespace-nowrap">{{ item | clientName }}</span>
	</div>
	<div *ngIf="item.type === clientTypes.BUILDER" class="flex">
		<app-icon
			[icon]="ICON.BUILDER"
			class="mr-2"
			[testHook]="testHooks.BuilderIcon"
		></app-icon
		><span class="whitespace-nowrap">{{ item | clientName }}</span>
	</div>
</ng-template>

<ng-template #searchingLeapDbTemplate let-item>
	<div class="flex gap-3 pt-6 px-0">
		<app-icon
			class="text-gray-400 text-sm"
			[spin]="item.spin"
			[icon]="item.icon"
			[testHook]="testHooks.Icon"
		></app-icon>
		<span class="font-normal text-gray-400 text-sm">{{ item.text }}</span>
	</div>
</ng-template>

<div *ngIf="!selected" (clickOutside)="showDropdown = false">
	<app-input
		[label]="label"
		[startIcon]="ICON.SEARCH"
		(debounce)="debounce($event)"
		[ngModel]="searchValue$ | async"
		(ngModelChange)="updateSearchValue($event)"
		[placeholder]="'Search ' + label"
		[testHook]="testHooks.SearchValue"
		(onFocus)="handleOnInputFocus()"
		[skeletonLoading]="skeletonLoading"
		[labelIcon]="labelIcon"
		[labelToolTip]="labelToolTip"
		[labelIconClasses]="labelIconClasses"
	>
	</app-input>
	<div class="relative">
		<app-dropdown-options
			(clickOutside)="showDropdown = false"
			[show]="showDropdown"
			[loading]="showLoading$ | async"
			[itemGroups]="itemGroups$ | async"
			(onSelect)="_onSelect($event)"
			class="w-full"
			[testHook]="testHooks.DropdownOptions"
		></app-dropdown-options>
	</div>
</div>
